var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserCircleYellow48Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8E510AD7-2439-453E-BBCE-FD13B76B843E_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M48,24 C48,37.2548348 37.2548348,48 24,48 C10.7451652,48 0,37.2548348 0,24 C0,10.7451652 10.7451652,0 24,0 C37.2548348,0 48,10.7451652 48,24 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-784.000000, -469.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(752.000000, 392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_User-Circle_Yellow-48px",
    transform: "translate(32.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke-3-+-Stroke-5-Mask"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFCD00",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3043478,14.5652174 C31.4086957,10.6 28.2782609,7.36521739 24.3130435,7.26086957 C24.2086957,7.26086957 24.1043478,7.26086957 24,7.26086957 C20.0347826,7.15652174 16.8,10.2869565 16.6956522,14.2521739 C16.6956522,14.3565217 16.6956522,14.4608696 16.6956522,14.5652174 C16.6956522,15.4 17.5304348,19.4695652 17.5304348,19.4695652 C18.1565217,23.0173913 20.4521739,26.0434783 24,26.0434783 C27.5478261,26.0434783 29.8434783,23.1217391 30.4695652,19.4695652 C30.4695652,19.4695652 31.3043478,15.4 31.3043478,14.5652174 Z",
    id: "Stroke-3",
    stroke: "#000000",
    strokeWidth: 2,
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26086957,41.173913 L6.26086957,39.4434783 C6.26086957,36.2086957 8.66086957,33.8086957 11.8956522,32.973913 L11.8956522,32.973913 C19.8976663,31.5252726 28.0972126,31.5530247 36.0892373,33.0557986 L36.2086957,33.0782609 C39.3391304,34.0173913 41.7391304,36.2086957 41.7391304,39.5478261 L41.7391304,41.2782609",
    id: "Stroke-5",
    stroke: "#000000",
    strokeWidth: 2,
    mask: "url(#mask-2)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserCircleYellow48Px);
export default __webpack_public_path__ + "static/media/Icon_User-Circle_Yellow-48px.2b29f367d6c4fd48e0df6c50fa68362a.svg";
export { ForwardRef as ReactComponent };